import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { deleteContact } from '../../actions/contact';
import { Icon, makeStyles } from '@material-ui/core';

const ContactHead = ({ contact, deleteContact, history }) => {
  const useStyles = makeStyles(theme => ({
    nameDiv: {
      display: 'flex'
    },
    contactName: { width: '20%' },
    deleteIcon: {
      marginLeft: '75%'
    },
    editIcon: {
      marginLeft: '1%'
    }
  }));

  const onClickDelete = id => {
    deleteContact(id, history);
  };

  const classes = useStyles();

  return (
    <div>
      <div className={classes.nameDiv}>
        <div className={classes.contactName}>
          <h2>
            <span>{contact.firstName}</span>&nbsp;
            <span>{contact.lastName}</span>
          </h2>
        </div>
        <div className={classes.deleteIcon}>
          <Icon
            className='fas fa-trash-alt'
            style={{ color: '#333', fontSize: 15 }}
            onClick={e => onClickDelete(contact._id)}
          ></Icon>
        </div>
        <div className={classes.editIcon}>
          <Link to={`/edit_contact/${contact._id}`}>
            <Icon
              className='fas fa-pen'
              style={{ color: '#333', fontSize: 15 }}
            ></Icon>
          </Link>
        </div>
      </div>
      <div>
        <p>{contact.organization}</p>
        <p>{contact.phone}</p>
        <p>{contact.email}</p>
        <p>
          <a href={`${contact.url}`}>{contact.url}</a>
        </p>
      </div>
    </div>
  );
};

ContactHead.propTypes = {
  contact: PropTypes.object.isRequired,
  deleteContact: PropTypes.func.isRequired
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, { deleteContact })(
  withRouter(ContactHead)
);



// WEBPACK FOOTER //
// ./src/components/contact/ContactHead.js